import { object, string } from 'libs/form';
import { TFunc } from 'libs/i18n';

const LENGTH = 200;

export const getDetailsSchema = (t: TFunc) =>
  object({
    custodianOrganization: object({
      value: string().required(),
      label: string().required(),
    })
      .test('len', (val, ctx) => {
        if (val?.label && val?.label.length > LENGTH) {
          return ctx.createError({
            message: t('validation.max', { max: LENGTH }),
          });
        }
        return true;
      })
      .required()
      .default(null),
    accountNumber: string().required().max(50),
    accountOwnerName: string().required().max(200),
    brokerName: object({
      value: string().required(),
      label: string().required(),
    })
      .test('len', (val, ctx) => {
        if (val?.label && val?.label.length > LENGTH) {
          return ctx.createError({
            message: t('validation.max', { max: LENGTH }),
          });
        }
        return true;
      })
      .required()
      .default(null),

    custodianOrganizationCode: string().nullable(),
  });
